module.exports = __webpack_public_path__ + "img/upgrade6.9ef5bb1e.png";